import { Component, Vue } from 'vue-property-decorator';
import { GenericTree, GenericTreeNode } from './GenericTreeClass';

@Component
export default class GenericTreeUtils extends Vue{

    /** Indique si l'aborescence est ouverte sur les noeuds selectionné */
    protected IsExpandSelected: boolean = false;

    /** Replie l'arborescence */
    protected collapseExpandFolderTree(root: GenericTree){
        const unfold = (nodes: GenericTreeNode[]) =>{
            if(nodes){
                for(let node of nodes){
                    node.Expanded = false;
                    unfold(node.ChildNodes)
                }
            }
        } 
        const foldSelection = (nodes: GenericTreeNode[]): boolean =>{
            let found = false;
            if(nodes){
                for(let node of nodes){
                    if(node.Checked){
                        node.Expanded = true;
                        found = true;
                        for(let child of node.ChildNodes)
                            node.Expanded = true;
                    }
                    if(foldSelection(node.ChildNodes)){
                        node.Expanded = true;
                        found = true;
                    }
                }
            }
            return found;
        }

        if(this.IsExpandSelected){
            unfold(root.Nodes);
        }
        else
            foldSelection(root.Nodes);
        this.IsExpandSelected = !this.IsExpandSelected;
    }

    /** Initialise la selection des id passé en paramètre */
    protected initSelection(root: GenericTree, idNodes: string[]){
        idNodes.forEach(idNode => {
            const searchNode = root.FlatNodes[idNode];
            if(searchNode)
                this.selectNode(root,searchNode);
        });
    }

    /** 
     * Replie ou déplie le visuel des enfants. 
     * @param node Noeud à étendre
     */
    protected toggleExpandNode(node: GenericTreeNode){
        node.Expanded = !node.Expanded;
    }

    /** 
     * Retire la selection d'un noeud 
     * @param root Racine de l'arbre contenant les métadonnées de l'arbre
     * @param node Noeud à dé-sélectionner
     */
    protected unSelectNode(root: GenericTree, node: GenericTreeNode){
        node.Checked = false;
        const index: number = root.SelectedNodes.findIndex(n => n.Id === node.Id);
        if(index > -1) {
            root.SelectedNodes.splice(index, 1);
            if(root.CurrentSelectedNode && root.CurrentSelectedNode.Id === node.Id) /** Est-ce que le noeud en cour de selection */
                root.CurrentSelectedNode = null;
            this.$emit("UnselectedEvent", node);
        }
    }

    /** 
     * Selectionne le noeud dans l'arbre 
     * @param root Racine de l'arbre contenant les métadonnées de l'arbre
     * @param node Noeud à sélectionner
     */
    protected selectNode(root: GenericTree, node: GenericTreeNode){
        node.Checked = true;
        this.checkOnParent(root, node, node.Checked)
        this.checkOnChilds(root, node, node.Checked);
        const index: number = root.SelectedNodes.findIndex(n => n.Id === node.Id);
        if(index < 0) {
            root.SelectedNodes.push(node);
            root.CurrentSelectedNode = node;
            this.$emit("SelectedEvent", node);
        }
    }

    /** 
     * Met à jour les métadonées de l'arbre 
     * @param root Racine de l'arbre contenant les métadonnées de l'arbre
     * @param node Noeud à permuter
     */
    protected toggleSelectedNode(root: GenericTree, node: GenericTreeNode){
        if(node.Checked)
            this.unSelectNode(root, node);
        else
            this.selectNode(root, node);
    }

    /** 
     * Retire la selection chez les parents
     * @param root Racine de l'arbre contenant les métadonnées de l'arbre
     * @param node Noeud en cours
     * @param state Statut propagé dans les parents
     */
    private checkOnParent(root: GenericTree, node: GenericTreeNode, state: boolean){
        if(node.ParentNode){
            node.ParentNode.Expanded = true;
            if(state && node.ParentNode.Checked){
                this.unSelectNode(root, node.ParentNode);
            }
            // node.FatherNode.NestedChecked = state;
            this.checkOnParent(root, node.ParentNode,state);
        }
    }

    /** 
     * Retire la selection chez les fils 
     * @param root Racine de l'arbre contenant les métadonnées de l'arbre
     * @param node Noeud en cours
     * @param state Statut propagé dans les fils
     */
    private checkOnChilds(root: GenericTree, node : GenericTreeNode, state: boolean){
        if(!state) return;
        // node.NestedChecked = false;
        for(let child of node.ChildNodes ){
            if(child.Checked){
                this.unSelectNode(root, child);
            }
            this.checkOnChilds(root, child, state);
        }
    }
}